import { render, staticRenderFns } from "./EnablingTypesRegistryEditForm.vue?vue&type=template&id=c0e0c5d4"
import script from "./EnablingTypesRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./EnablingTypesRegistryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports